"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalServiceImpl = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var services_1 = require("@falcon/services");
var VulnerableCustomerAction_1 = require("../../model/VulnerableCustomerAction");
var SupportPortalServiceImpl = /** @class */ (function (_super) {
    __extends(SupportPortalServiceImpl, _super);
    function SupportPortalServiceImpl(configuration, notificationService) {
        var _this = _super.call(this) || this;
        _this.configuration = configuration;
        _this.notificationService = notificationService;
        return _this;
    }
    SupportPortalServiceImpl.prototype.getPendingMtas = function (agreementNumber, agreementVersionId) {
        return this.doRequest("/pending-mtas?agreementNumber=".concat(agreementNumber, "&agreementVersionId=").concat(agreementVersionId), undefined, undefined, "getPendingMtas error.", [], true);
    };
    SupportPortalServiceImpl.prototype.search = function (searchInput) {
        return (0, rxjs_1.of)({});
    };
    SupportPortalServiceImpl.prototype.updateUser = function (user, customerReferenceNumber) {
        return _super.prototype.getProtectedResource.call(this, {
            body: user,
            method: "POST",
            headers: this.configuration.customHeaders,
            url: "".concat(this.configuration.serviceBaseUrl, "/parties/").concat(customerReferenceNumber, "/update-user"),
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            return (0, rxjs_1.of)(err);
        }));
    };
    SupportPortalServiceImpl.prototype.updateUserEmail = function (user, customerReferenceNumber) {
        return (0, rxjs_1.of)({});
    };
    SupportPortalServiceImpl.prototype.getParty = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber), undefined, undefined, "Get party error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPartyByReference = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/partyByReference"), undefined, undefined, "Get party error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getParties = function (partySearchCriteria) {
        return this.doRequest("/parties/search", "POST", this.removeEmptyParameters(partySearchCriteria), "Get parties error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPartiesAdvanced = function (queryParameters) {
        var queryString = "";
        Object.entries(queryParameters).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined && value !== null && value !== "") {
                if (Array.isArray(value)) {
                    value.forEach(function (v) {
                        queryString += "".concat(key, "=").concat(encodeURIComponent(v), "&");
                    });
                }
                else {
                    queryString += "".concat(key, "=").concat(encodeURIComponent(String(value)), "&");
                }
            }
        });
        return this.doRequest("/parties/advanced?".concat(queryString), undefined, undefined, "Get parties error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPolicies = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/policies"), undefined, undefined, "Get policies error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getPoliciesForBackdating = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/policies?userId=BackdatingTool&"), undefined, undefined, "Get policies for backdating error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getPolicyVersionDetails = function (customerReferenceNumber, policyNumber, policyVersionNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/policies/").concat(policyNumber, "/versions/").concat(policyVersionNumber), undefined, undefined, "Get policy version details error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getDocuments = function (policyNumber, policyVersionNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/versions/").concat(policyVersionNumber, "/documents"), undefined, undefined, "Get documents error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getRenewalDocuments = function (policyNumber, policyVersionNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/versions/").concat(policyVersionNumber, "/renewalDocuments"), undefined, undefined, "Get renewal documents error.", [], false);
    };
    SupportPortalServiceImpl.prototype.getDocumentWithContent = function (documentId) {
        return this.doRequest("/documents/".concat(documentId), undefined, undefined, "Get document with content error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.downloadDocument = function (documentId) {
        var thisWrap = this;
        // tslint:disable-next-line:max-classes-per-file
        this.requestModifiers.push(new /** @class */ (function () {
            function class_1() {
            }
            class_1.prototype.modifyHttpRequest = function (request) {
                request.headers = request.headers || {};
                request.headers.Accept = "application/octet-stream";
                request.responseType = "blob";
                return thisWrap.applicationGuard.modifyHttpRequest(request);
            };
            return class_1;
        }()));
        return this.doRequest("/documents/".concat(documentId, "/download"), undefined, undefined, "Download document error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.uploadDocument = function (document, policyNumber, policyVersionNumber, process, interactionId) {
        return this.doRequest("/documents/".concat(policyNumber, "/upload/").concat(policyVersionNumber, "?process=").concat(process, "&interactionId=").concat(interactionId), "POST", document, "Failed to upload document.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getCommunications = function (policyNumber, policyVersionNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/versions/").concat(policyVersionNumber, "/communications"), undefined, undefined, "Get communications error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getSms = function (policyNumber, policyVersionNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/versions/").concat(policyVersionNumber, "/sms"), undefined, undefined, "Get SMS error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getRenewalCommunications = function (policyNumber, policyVersionNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/versions/").concat(policyVersionNumber, "/renewalCommunications"), undefined, undefined, "Get renewal communications error.", [], false);
    };
    SupportPortalServiceImpl.prototype.getCommunicationWithContent = function (communicationId) {
        return this.doRequest("/communications/".concat(communicationId), undefined, undefined, "Get communication with content error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getInvoices = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/invoices"), undefined, undefined, "Get invoices error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getFalconInvoices = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/falconInvoices"), undefined, undefined, "Get falcon invoices error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPayments = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/falconPayments"), undefined, undefined, "Get falcon payments error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.markPaymentAsChargeback = function (customerReferenceNumber, paymentId) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/falconPaymentsChargeback/").concat(paymentId), "POST", undefined, "Mark payment as chargeback operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getCreditCard = function (cardId) {
        return this.doRequest("/parties/".concat(cardId, "/creditCard"), undefined, undefined, "Get credit card error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getCustomerCards = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/customerCards"), undefined, undefined, "Get customer cards error.", [], true);
    };
    SupportPortalServiceImpl.prototype.setVulnerableCustomerFlag = function (customerReferenceNumber, flag) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/vulnerableCustomer?flag=").concat(flag), "POST", undefined, "Setting 'Vulnerable Customer' flag operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getVulnerableCustomerFlag = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/vulnerableCustomer"), undefined, undefined, "Get vulnerable customer flag error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getDeceasedCustomerFlag = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/deceased"), undefined, undefined, "Get deceased customer flag error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.markAsDeceased = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/deceased"), "POST", undefined, "Mark as deceased", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.startVulnerableCustomerAction = function (customerReferenceNumber, agreementNumber, action, months) {
        var actionPathName = VulnerableCustomerAction_1.VulnerableCustomerActionHelper.getActionEndpointPathName(action);
        var flags = months ? "?months=".concat(months) : "";
        return this.doRequest("/policies/".concat(customerReferenceNumber, "/").concat(agreementNumber, "/vulnerableCustomer/action/").concat(actionPathName).concat(flags), "POST", undefined, "Failed to start Vulnerable Customer action: ".concat(action), new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.previewPaymentHolidaySchedule = function (customerReferenceNumber, agreementNumber, months) {
        return this.doRequest("/policies/".concat(customerReferenceNumber, "/").concat(agreementNumber, "/vulnerableCustomer/paymentHoliday/preview?months=").concat(months), "GET", undefined, "Failed to start Vulnerable Customer: PAYMENT HOLIDAY", undefined, true);
    };
    SupportPortalServiceImpl.prototype.cancelVulnerableCustomerAction = function (customerReferenceNumber, agreementNumber, action) {
        var actionPathName = VulnerableCustomerAction_1.VulnerableCustomerActionHelper.getActionEndpointPathName(action);
        return this.doRequest("/policies/".concat(customerReferenceNumber, "/").concat(agreementNumber, "/vulnerableCustomer/action/").concat(actionPathName, "/cancel"), "POST", undefined, "Failed to cancel Vulnerable Customer action: ".concat(action), new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getActiveVulnerableCustomerAction = function (agreementNumber) {
        return this.doRequest("/policies/".concat(agreementNumber, "/vulnerableCustomer/action"), "GET", undefined, "Failed to get currently active Vulnerable Customer action", VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE, true);
    };
    SupportPortalServiceImpl.prototype.getActiveVulnerableCustomerActions = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/vulnerableCustomer/actions"), "GET", undefined, "Failed to get currently active Vulnerable Customer action", [], true);
    };
    SupportPortalServiceImpl.prototype.getActiveAdditionalSupportRecord = function (agreementNumber) {
        return this.doRequest("/vulnerableCustomerAdditionalSupport/get/".concat(agreementNumber), "GET", undefined, "Failed to get Vulnerable Customer active additional support record", [], true);
    };
    SupportPortalServiceImpl.prototype.createAdditionalSupportRecord = function (record) {
        return this.doRequest("/vulnerableCustomerAdditionalSupport/create", "POST", record, "Failed to create Vulnerable Customer additional support record", true, true);
    };
    SupportPortalServiceImpl.prototype.updateAdditionalSupportRecord = function (record) {
        return this.doRequest("/vulnerableCustomerAdditionalSupport/update", "PUT", record, "Failed to update Vulnerable Customer additional support record", true, true);
    };
    SupportPortalServiceImpl.prototype.deactivateAdditionalSupportRecord = function (referenceNumber) {
        return this.doRequest("/vulnerableCustomerAdditionalSupport/".concat(referenceNumber, "/deactivate"), "POST", undefined, "Failed to remove Vulnerable Customer active additional support record", [], true);
    };
    SupportPortalServiceImpl.prototype.getAdditionalSupportRecordHistory = function (agreementNumber, userId, limit, offset) {
        return this.doRequest("/vulnerableCustomerAdditionalSupport/history/".concat(agreementNumber, "?limit=").concat(limit, "&offset=").concat(offset), "GET", undefined, "Failed to get Vulnerable Customer additional support records", [], true);
    };
    SupportPortalServiceImpl.prototype.getAdditionalSupportRecordHistoryRecordCount = function (agreementNumber, userId) {
        return this.doRequest("/vulnerableCustomerAdditionalSupport/historycount/".concat(agreementNumber), "GET", undefined, "Failed to get Vulnerable Customer additional support record count", [], true);
    };
    SupportPortalServiceImpl.prototype.getNumberOfRemainingInstalments = function (customerReferenceNumber, agreementVersionId) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/vulnerableCustomer/action/suspendInterest/remainingInstalments?agreementVersionId=").concat(agreementVersionId), "GET", undefined, "Get number of remaining instalments error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.setFraudFlag = function (customerReferenceNumber, flag) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/fraud?flag=").concat(flag), "POST", undefined, "Fraud operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getFraudFlag = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/fraud"), undefined, undefined, "Get fraud flag error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getLastVRNChangeDate = function (customerReferenceNumber, policyNumber) {
        return this.doRequest("/".concat(customerReferenceNumber, "/property/").concat(policyNumber, "/lastVRNChangeDate"), undefined, undefined, "Get last vrn change date error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.unlockVRNChange = function (customerReferenceNumber, policyNumber, vehicleRegistrationNumber) {
        return this.doRequest("/".concat(customerReferenceNumber, "/property/").concat(policyNumber, "/unlockVRNChange/").concat(vehicleRegistrationNumber), "POST", undefined, "VRN unlocking operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.deleteFraudBlockList = function (fraudBlockList) {
        return this.doRequest("/fraudblocklist/delete/", "POST", fraudBlockList, "FraudBlockList operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getFraudBlockList = function (drivingLicenceNumber) {
        return this.doRequest("/fraudblocklist/retrieve/".concat(drivingLicenceNumber), undefined, undefined, "Get fraud block list error.", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getNotes = function (customerReferenceNumber, offset, limit) {
        var queryParameters = new URLSearchParams({
            offset: String(offset),
            limit: String(limit)
        });
        return this.doRequest("/parties/".concat(encodeURIComponent(customerReferenceNumber), "/notes?").concat(queryParameters.toString()), "GET", undefined, "Get notes error.", [], true);
    };
    SupportPortalServiceImpl.prototype.createNote = function (customerReferenceNumber, data) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/notes"), "POST", data, "Create notes error.", [], true);
    };
    SupportPortalServiceImpl.prototype.deleteNote = function (involvedObjectNumber, noteId) {
        return this.doRequest("/parties/".concat(involvedObjectNumber, "/notes/").concat(noteId), "DELETE", undefined, "Delete notes error.", [], true);
    };
    SupportPortalServiceImpl.prototype.updateNote = function (involvedObjectNumber, noteId, data) {
        return this.doRequest("/parties/".concat(involvedObjectNumber, "/notes/").concat(noteId), "PUT", data, "Update notes error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getClaim = function (involvedObjectNumber, claimId) {
        return this.doRequest("/parties/".concat(involvedObjectNumber, "/claims/").concat(claimId), "GET", undefined, "Get claim error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getClaims = function (involvedObjectNumber) {
        return this.doRequest("/parties/".concat(involvedObjectNumber, "/claims"), "GET", undefined, "Get claims error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getClaimsAudit = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/claimaudit"), "GET", undefined, "Get claims audit error.", [], true);
    };
    SupportPortalServiceImpl.prototype.createClaim = function (customerReferenceNumber, data) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/claims"), "POST", data, "Create claim error.", [], true);
    };
    SupportPortalServiceImpl.prototype.deleteClaim = function (customerReferenceNumber, claimId) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/claims/").concat(claimId), "DELETE", undefined, "Delete claim error.", [], true);
    };
    SupportPortalServiceImpl.prototype.updateClaim = function (customerReferenceNumber, claimId, data) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/claims/").concat(claimId), "PUT", data, "Update claim error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getInteraction = function (interactionId) {
        var url = "/interactions/".concat(interactionId);
        return this.doRequest(url, undefined, undefined, "Get interaction error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getInteractions = function (queryParameters) {
        var queryString = this.buildQueryString(queryParameters);
        var hasMqsQuoteId = queryParameters.mqsQuoteId !== undefined &&
            queryParameters.mqsQuoteId !== null &&
            queryParameters.mqsQuoteId !== "";
        var basePath = hasMqsQuoteId
            ? "/interactions/by-mqs" // if mqsQuoteId present, calls: SupportPortalApi - FalconQuotesServiceImpl
            : "/interactions"; // if mqsQuoteId undefined, calls: Athena - QuotesRouteBuilder
        var url = queryString ? "".concat(basePath, "?").concat(queryString) : basePath;
        return this.doRequest(url, undefined, undefined, "Get interactions error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.markedForCancellationMaxDate = function (policyNumber) {
        return this.doRequest("/markedForCancellation/".concat(policyNumber), undefined, undefined, "Get marked for cancellation max date error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getCancellationDelayDate = function (policyNumber) {
        return this.doRequest("/cancellationDelayDate/".concat(policyNumber), undefined, undefined, "Get cancellation delay date error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getSubscriptionDrivers = function (customerReferenceNumber) {
        return this.doRequest("/drivers/".concat(customerReferenceNumber), undefined, undefined, "Get subscription drivers error.", [], true);
    };
    SupportPortalServiceImpl.prototype.doRefund = function (policyNumber, refund) {
        return this.doRequest("/policies/".concat(policyNumber, "/refund"), "PUT", refund, "Refund operation was not successful.\nFor more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getCardMaxRefundAmount = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/getCardMaxRefundAmount"), undefined, undefined, "Get card max refund amount error.", [], true);
    };
    SupportPortalServiceImpl.prototype.doGoodwillPayment = function (policyNumber, payment) {
        return this.doRequest("/policies/".concat(policyNumber, "/goodwillPayment"), "PUT", payment, "Goodwill payment operation was not successful.\nFor more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getAgentCancellationReasons = function (role, product) {
        return this.doRequest("/agent-cancellation-reasons/".concat(role, "?product=").concat(product), undefined, undefined, "Get agent cancellation reasons error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.createExternalClaim = function (customerReferenceNumber, request) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/externalClaims"), "POST", request, "Unable to create the claim. \nFor more details contact your administrator", undefined, true);
    };
    SupportPortalServiceImpl.prototype.createCancellationDelay = function (request) {
        return this.doRequest("/delayCancellation", "POST", request, "Cancellation delay was not successful", undefined, true);
    };
    SupportPortalServiceImpl.prototype.removeCancellationDelay = function (policyNumber) {
        return this.doRequest("/delayCancellation", "DELETE", { policyNumber: policyNumber }, "Cancellation delay removal was not successful", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getUnderwritingUpdates = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/externalClaims"), undefined, undefined, "Get underwriting updates error.", [], true);
    };
    SupportPortalServiceImpl.prototype.setAutomaticRenewalFlag = function (customerReferenceNumber, policyNumber, flag) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/").concat(policyNumber, "/autorenewal?flag=").concat(flag), "POST", undefined, "Auto renewal flag change operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.setPerformRenewalFlag = function (customerReferenceNumber, policyNumber, flag) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/").concat(policyNumber, "/performrenewal?flag=").concat(flag), "POST", undefined, "Perform renewal flag change operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.renewPolicyFromSupportPortal = function (customerReferenceNumber, policyNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/").concat(policyNumber, "/renewPolicySupportPortal"), "POST", undefined, "Manual support portal renewal process was not successful. See the logs", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getAutomaticRenewalFlag = function (customerReferenceNumber, policyNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/").concat(policyNumber, "/autorenewal"), undefined, undefined, "Get automatic renewal flag error.", [], true);
    };
    SupportPortalServiceImpl.prototype.setSuppressRenewalFlag = function (customerReferenceNumber, policyNumber, flag) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/").concat(policyNumber, "/suppressrenewal?flag=").concat(flag), "POST", undefined, "Issue renewal flag change operation was not successful. For more details contact your administrator", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getSuppressRenewalFlag = function (customerReferenceNumber, policyNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/").concat(policyNumber, "/suppressrenewal"), undefined, undefined, "Get issue renewal flag error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getRenewalProposal = function (agreementNumber) {
        var url = "/renewals/proposal/".concat(agreementNumber, "/renewalProposal");
        return this.doRequest(url, undefined, undefined, "Get renewal proposal error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getUserEvents = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/userEvents"), undefined, undefined, "Get user event error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getAgentEvents = function (customerReferenceNumber) {
        return this.doRequest("/activity/".concat(customerReferenceNumber, "/agentActivity"), undefined, undefined, "Get agent event error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getAvailablePolicyDocuments = function (policyProduct, policyStatus) {
        return this.doRequest("/policy/availablePolicyDocuments/".concat(policyProduct, "?policyStatus=").concat(policyStatus), undefined, undefined, "Get available policy documents error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getAvailablePolicyCommunications = function (policyProduct, policyStatus) {
        return this.doRequest("/policy/availablePolicyCommunications/".concat(policyProduct, "?policyStatus=").concat(policyStatus), undefined, undefined, "Get available policy communications error.", [], true);
    };
    SupportPortalServiceImpl.prototype.generatePolicyDocuments = function (documents, policyNumber, interactionId) {
        return this.doRequest("/policy/generatePolicyDocuments", "POST", {
            documents: documents,
            policyNumber: policyNumber,
            interactionId: interactionId
        }, "Generate policy documents error.", [], true);
    };
    SupportPortalServiceImpl.prototype.retryPayment = function (customerReferenceNumber, invoiceDate, invoiceId) {
        return this.doRequest("/policy/retryPayment", "POST", {
            customerReferenceNumber: customerReferenceNumber,
            invoiceDate: invoiceDate,
            invoiceId: invoiceId
        }, "Get retry payment error.", [], true);
    };
    SupportPortalServiceImpl.prototype.writeOffInvoice = function (customerReferenceNumber, policyNumber, invoiceId) {
        return this.doRequest("/policy/writeOffInvoice", "POST", {
            customerReferenceNumber: customerReferenceNumber,
            policyNumber: policyNumber,
            invoiceId: invoiceId
        }, "Get write-off invoice error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getIdentityUser = function (customerReferenceNumber) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/identityUser"), undefined, undefined, "Get identify user error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.deleteIdentityUserByEmail = function (email) {
        return this.doRequest("/parties/".concat(email, "/deleteIdentityUserByEmail"), "DELETE", undefined, "Delete user error", new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.updateIdentityUser = function (customerReferenceNumber, updatedUser) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/updateIdentityUser"), "POST", updatedUser, "Update identity user error.", [], true);
    };
    SupportPortalServiceImpl.prototype.getInvoiceCorrectionInformation = function (policyNumber) {
        return this.doRequest("/parties/invoiceCorrection/".concat(policyNumber), undefined, undefined, "Get invoice correction information error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.applyInvoiceCorrection = function (policyNumber) {
        return this.doRequest("/parties/invoiceCorrection/".concat(policyNumber), "POST", undefined, "Failed to apply correction for policy ".concat(policyNumber), new Error(''), true);
    };
    SupportPortalServiceImpl.prototype.getPolicyPropertyByPropertyKey = function (policyNumber, propertyKey, userId) {
        return this.doRequest("/policy/property/".concat(policyNumber, "/").concat(propertyKey, "/").concat(userId), "GET", undefined, "Failed to get policy property ".concat(propertyKey, " for policy ").concat(policyNumber), undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPolicyPropertiesByPropertyKeys = function (policyNumber, propertyKeys) {
        return this.doRequest("/policy/properties/".concat(policyNumber), "POST", propertyKeys, "Failed to get policy properties for policy ".concat(policyNumber), undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPolicyVersionPropertiesByPropertyKeys = function (policyNumber, propertyKeys) {
        return this.doRequest("/policy/properties/version/".concat(policyNumber), "POST", propertyKeys, "Failed to get policy properties for policy ".concat(policyNumber), undefined, true);
    };
    SupportPortalServiceImpl.prototype.getMandatesByPolicyNumber = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/getMandatesByPolicyNumber"), "GET", undefined, "Failed to upload mandate for policy ".concat(policyNumber), undefined, true);
    };
    SupportPortalServiceImpl.prototype.getPaymentsRequestByPolicyNumber = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/getPaymentRequestsByPolicyNumber"), "GET", undefined, "Failed to upload payment requests for policy ".concat(policyNumber), undefined, true);
    };
    SupportPortalServiceImpl.prototype.getDelinquencyHistoryByPolicyNumber = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/getDelinquencyHistoryByPolicyNumber"), "GET", undefined, "Delinquencies for policy ".concat(policyNumber, " not found"), undefined, true);
    };
    SupportPortalServiceImpl.prototype.getBacsResponsesByPolicyNumber = function (policyNumber) {
        return this.doRequest("/policies/".concat(policyNumber, "/getBacsResponsesByPolicyNumber"), "GET", undefined, "BACS Responses retrieval failed", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getBacsDocumenById = function (bacsDocumentId) {
        return this.doRequest("/policies/".concat(bacsDocumentId, "/getBacsDocument"), "GET", undefined, "BACS Document retrieval failed", undefined, true);
    };
    SupportPortalServiceImpl.prototype.calculateInteraction = function (interaction) {
        return this.doRequest("/calculateInteraction", "POST", interaction, "Failed to calculate interaction", undefined, true);
    };
    SupportPortalServiceImpl.prototype.setPassword = function (customerReferenceNumber, password, isTemporary) {
        return this.doRequest("/parties/".concat(customerReferenceNumber, "/setPassword"), "POST", {
            password: password,
            isTemporary: isTemporary
        }, "Setting password was not successful. For more details contact your administrator", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getTransactions = function (transactionSearchCriteria) {
        return this.doRequest("/transactions/search", "POST", this.removeEmptyParameters(transactionSearchCriteria), "Get transactions error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.logAgentActivity = function (customerReference, body) {
        return this.doRequest("/activity/".concat(customerReference, "/logAgentActivity"), "POST", body, "Failed to log agent activity", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getFailedRefundInfo = function (policyNumber) {
        return this.doRequest("/parties/failedRefundInfo/".concat(policyNumber), undefined, undefined, "Error getting failed refund information.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.markRefundInvoiceAsPaid = function (policyNumber, invoiceId) {
        return this.doRequest("/policies/".concat(policyNumber, "/markRefundInvoiceAsPaid"), "POST", {
            invoiceId: invoiceId
        }, "Failed to mark refund invoice as PAID.", [], true);
    };
    SupportPortalServiceImpl.prototype.getAvailablePaymentDays = function (customerReferenceNumber, policyNumber) {
        return this.doRequest("/policies/".concat(customerReferenceNumber, "/policy/").concat(policyNumber, "/available-payment-days"), 'GET', undefined, "Error getting available payment days", undefined, true);
    };
    SupportPortalServiceImpl.prototype.storePaymentDay = function (customerReferenceNumber, policyNumber, value) {
        return this.doRequest("/policies/".concat(customerReferenceNumber, "/policy/").concat(policyNumber, "/update-payment-day"), 'POST', value.toString(), "Failed to store payment day", undefined, true);
    };
    SupportPortalServiceImpl.prototype.storeAnnualToMonthlyPaymentDay = function (customerReferenceNumber, policyNumber, value) {
        return this.doRequest("/policies/".concat(customerReferenceNumber, "/policy/").concat(policyNumber, "/update-annual-to-monthly-payment-day"), 'POST', value.toString(), "Failed to store payment day", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getCombinedInstalmentsInfo = function (agreementVersionIds) {
        var queryString = "agreementVersionIds=";
        for (var i = 0; i < agreementVersionIds.length; i++) {
            queryString += agreementVersionIds[i];
            if (i < agreementVersionIds.length - 1) {
                queryString += ",";
            }
        }
        return this.doRequest("/profile/payments/instalmentsInfo?".concat(queryString), "GET", undefined, "Error getting combined instalments info.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getCombinedInstalmentsInfoByPartyReference = function (partyReference) {
        return this.doRequest("/profile/payments/".concat(partyReference, "/instalmentsInfo"), undefined, undefined, "Get instalments info error.", undefined, true);
    };
    SupportPortalServiceImpl.prototype.getOptionalExtrasInformation = function (policyNumber) {
        var searchParams = new URLSearchParams();
        searchParams.append("policyNumber", policyNumber);
        return this.doRequest("/profile/optionalExtrasInformation?".concat(searchParams.toString()), undefined, undefined, "Get optional extras error.", undefined, true);
    };
    // @ts-ignore
    SupportPortalServiceImpl.prototype.doRequest = function (urlAppend, method, body, errorMessage, onErrorReturn, showErrorMessage) {
        var _this = this;
        return _super.prototype.getProtectedResource.call(this, {
            body: body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: "".concat(this.configuration.serviceBaseUrl).concat(urlAppend),
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            if (showErrorMessage === undefined || showErrorMessage) {
                _this.notificationService.push({
                    level: "ERROR",
                    message: errorMessage || " Service error! For more details contact your administrator."
                });
            }
            return (0, rxjs_1.throwError)(err);
        }));
    };
    SupportPortalServiceImpl.prototype.buildQueryString = function (params) {
        return Object.entries(params)
            .filter(function (_a) {
            var value = _a[1];
            return value !== undefined && value !== null && value !== "";
        })
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return "".concat(key, "=").concat(encodeURIComponent(String(value)));
        })
            .join("&");
    };
    SupportPortalServiceImpl.prototype.removeEmptyParameters = function (criteria) {
        return Object.fromEntries(Object.entries(criteria)
            .filter(function (_a) {
            var _ = _a[0], value = _a[1];
            return value !== "";
        }));
    };
    SupportPortalServiceImpl = __decorate([
        (0, core_1.injectable)(),
        __param(0, (0, core_1.inject)(Types_1.Types.SupportPortalServiceConfig)),
        __param(1, (0, core_1.inject)(services_1.Types.NotificationService)),
        __metadata("design:paramtypes", [Object, Object])
    ], SupportPortalServiceImpl);
    return SupportPortalServiceImpl;
}(core_1.RestService));
exports.SupportPortalServiceImpl = SupportPortalServiceImpl;
//# sourceMappingURL=SupportPortalServiceImpl.js.map